import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const DownArrowIcon = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.79288 7L11.7929 15L19.7929 7L20.5 7.7071L11.7929 16.4142L3.08577 7.7071L3.79288 7Z"
      fill="#FFFEF4"
    />
  </svg>,
  'DownArrow'
);
